import { useState } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';

import { LoginForm } from '@components/LoginForm';
import { ForgotPassDialog } from '@components/dialogs/ForgotPassDialog';
import { useStyles } from './styles/Login.styles';
import { Box, Link } from '@mui/material';
import { REGISTER_URL } from '@consts/urls';

export const Login = () => {
    const classes = useStyles();

    const [showForgotPass, setShowForgotPass] = useState(false);

    return (
        <div className={classes.container}>
            <div className={classes.mainContent}>
                <div className={classes.base}>
                    <div className={classes.root} title='Login'>
                        <Card className={classes.card}>
                            <CardContent className={classes.content}>
                                <img src='/logo.png' />

                                <Typography className={classes.title}>Log in to MO Insights</Typography>

                                <LoginForm />

                                <Divider className={classes.divider} />

                                <Box className={classes.linksContainer}>
                                    <Button onClick={() => setShowForgotPass(true)}>Forgot Password?</Button>

                                    <Divider orientation='vertical' variant='middle' flexItem />

                                    <Button>
                                        <Link href={REGISTER_URL} target='_blank' underline='none'>
                                            Register
                                        </Link>
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </div>

                    <ForgotPassDialog open={showForgotPass} onClose={() => setShowForgotPass(false)} />
                </div>
            </div>
        </div>
    );
};
